import { Controller } from '@hotwired/stimulus';
import { waitForDownload } from '../js/download';

// Lien ou formulaire d'un fichier préparé à la demande (PDF, ZIP) : jeton
// download_token joint à la requête, puis attente (js/download.js) :
// lien ou bouton d'envoi en attente (aria-busy, « Préparation… » dans la
// cible label s'il en a une), nouveau clic refusé jusqu'à l'arrivée du
// fichier. Lien : le navigateur suit l'adresse complétée, dans l'onglet ou
// dans un nouvel onglet (target).
export default class extends Controller {
    static targets = ['label'];
    static values = { label: { type: String, default: 'Préparation…' } };

    start(event) {
        if (this.pending) {
            event.preventDefault();
            return;
        }
        const url = new URL(this.element.href);
        url.searchParams.set('download_token', this.wait(this.element, this.hasLabelTarget ? this.labelTarget : null));
        this.element.href = url.toString();
    }

    submit(event) {
        if (this.pending) {
            event.preventDefault();
            return;
        }
        const button = event.submitter || this.element.querySelector('[type=submit]');
        let field = this.element.querySelector('input[name="download_token"]');
        if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = 'download_token';
            this.element.append(field);
        }
        field.value = this.wait(button, this.hasLabelTarget ? this.labelTarget : null);
    }

    wait(element, labelElement) {
        this.pending = true;
        const label = labelElement ? this.labelValue : null;
        return waitForDownload(element, label, () => { this.pending = false; }, labelElement || element);
    }
}
